/* istanbul ignore next */
const ACTIONS = {
    HANDLE_ONBLUR: 'HANDLE_ONBLUR',
    SET_FIELD: 'SET_FIELD',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    VALIDATE_EMAIL: 'VALIDATE_EMAIL',
    SET_PROPERTY_COUNT_FIELD: 'SET_PROPERTY_COUNT_FIELD',
    VALIDATE_PROPERTY_COUNT_FIELD: 'VALIDATE_PROPERTY_COUNT_FIELD',
    UPDATE_PROPERTY_COUNT_INFO: 'UPDATE_PROPERTY_COUNT_INFO',
    CREATE_WEBFORM_ACCOUNT: 'CREATE_WEBFORM_ACCOUNT',
    CREATE_WEBFORM_ACCOUNT_SERVICE_ERROR: 'CREATE_WEBFROM_ACCOUNT_SERVICE_ERROR',
    TOGGLE_WEBFORM_CONTINUE_BUTTON: 'TOGGLE_WEBFORM_CONTINUE_BUTTON',
    GET_WEBFORM_METADATA: 'GET_WEBFORM_METADATA',
    GET_WEBFORM_METADATA_SUCCESS: 'GET_WEBFORM_METADATA_SUCCESS'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    validateEmail(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_EMAIL,
            payload: {
                fieldVal
            }
        };
    },

    validatePropertyField(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_PROPERTY_COUNT_FIELD,
            payload: {
                fieldVal
            }
        };
    },

    setField(fieldName, fieldValue) {
        return {
            type: ACTIONS.SET_FIELD,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    setFieldError(field, msg) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                field,
                msg
            }
        };
    },

    handleFieldValOnBlur(id, value) {
        return {
            type: ACTIONS.HANDLE_ONBLUR,
            payload: {
                id,
                value
            }
        };
    },

    createWebformAccount(leadFormUserInfo) {
        return {
            type: ACTIONS.CREATE_WEBFORM_ACCOUNT,
            payload: {
                leadFormUserInfo
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.CREATE_WEBFORM_ACCOUNT_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_WEBFORM_CONTINUE_BUTTON
        };
    },

    getWebformMetadata() {
        return {
            type: ACTIONS.GET_WEBFORM_METADATA
        };
    },

    getWebformMetadataSuccess(webformDetails, defaultLocale) {
        return {
            type: ACTIONS.GET_WEBFORM_METADATA_SUCCESS,
            payload: {
                webformDetails,
                defaultLocale
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
